import type { Dispatch } from '@reduxjs/toolkit';
import type { SceneJsonDto } from '@seddi/scene';
import { setScene, updateScene } from '../store/appSlice';
import { importScene } from '../viewer/importScene';

export const setSceneFromId = async (dispatch: Dispatch, id: string) => {
  // fetch scene JSON
  const response = await fetch(`files/scenes/${id}/scenePlayground.json`);

  const { status } = response;
  if (status < 200 || status >= 400) {
    throw new Error();
  }

  const scene: SceneJsonDto = await response.json();
  setSceneFromJson(dispatch, scene);
};

export const setSceneFromJson = async (dispatch: Dispatch, sceneDto: SceneJsonDto) => {
  // import scene JSON
  const scene = await importScene(sceneDto);
  // set scene
  setScene(scene);
  // notify scene update
  dispatch(updateScene());
};
